import { sound } from '@pixi/sound';
import { AnimatedSprite, Container, Graphics, Sprite, Text } from 'pixi.js';
import { LOCALE_DATA } from '../constant';
import { Store, TextureFactory } from '../core';

class RestartButton extends Container {
  constructor() {
    super();

    const restartButton = new Sprite(TextureFactory.instance.getSingleTexture('/textures/ui/btn_restart.png'));
    restartButton.anchor.set(0.5);
    this.addChild(restartButton);

    let pressed: boolean = false;

    // 광고보고 이어하기!
    const text = new Text(LOCALE_DATA[Store.instance.state.locale].CONTINUE, {
      fontSize: 60,
      fontWeight: '900',
      fontFamily: 'gaegu',
      fontStyle: 'normal',
      align: 'center',
      fill: '#4a282f',
      letterSpacing: -6,
    });
    text.x = 40;
    text.y = -5;
    text.anchor.set(0.5);
    this.addChild(text);

    this.on('pointerdown', () => {
      sound.play('/audio/btn.mp3', { loop: false, volume: Store.instance.state.volume as number });
      pressed = true;
      this.scale.set(0.95);
    });

    this.on('pointerup', () => {
      if (pressed) {
        this.emit('clicked');
        this.scale.set(1);
      }
      pressed = false;
    });
    this.on('pointerupoutside', () => {
      pressed = false;
      this.scale.set(1);
    });
  }
}

class HomeButton extends Container {
  constructor() {
    super();

    const homeButton = new Sprite(TextureFactory.instance.getSingleTexture('/textures/ui/btn_long_home.png'));
    homeButton.anchor.set(0.5);

    this.addChild(homeButton);

    let pressed: boolean = false;

    const text = new Text(LOCALE_DATA[Store.instance.state.locale].GO_TO_HOME, {
      fontSize: Store.instance.state.locale === 'en-US' ? 55 : 60,
      fontWeight: '900',
      fontFamily: 'gaegu',
      fontStyle: 'normal',
      align: 'center',
      fill: '#4a282f',
      letterSpacing: -6,
    });
    text.x = 40;
    text.y = -5;
    text.anchor.set(0.5);
    this.addChild(text);

    this.on('pointerdown', () => {
      sound.play('/audio/btn.mp3', { loop: false, volume: Store.instance.state.volume as number });
      pressed = true;
      this.scale.set(0.95);
    });

    this.on('pointerup', () => {
      if (pressed) {
        this.emit('clicked');
        this.scale.set(1);
      }
      pressed = false;
    });
    this.on('pointerupoutside', () => {
      pressed = false;
      this.scale.set(1);
    });
  }
}

class GameOverUI extends Container {
  public scoreText: Text;
  public note: Text;
  public ninimoSprite: AnimatedSprite;
  public stageSprite: AnimatedSprite;
  public gameState: { stage: string; score: string; rank: number } = { stage: '', score: '', rank: -1 };

  constructor() {
    super();

    const dim = new Graphics();
    dim.beginFill(0x000000, 0.7);
    dim.drawRect(-540, -960, 1080, 1920);
    dim.endFill();
    this.addChild(dim);

    const base = new Sprite(TextureFactory.instance.getSingleTexture('/textures/ui/popup_score.png'));
    base.position.y = -40;
    base.anchor.set(0.5);
    this.addChild(base);

    this.ninimoSprite = new AnimatedSprite([
      TextureFactory.instance.getSingleTexture('/textures/ui/ninimo_1.png'),
      TextureFactory.instance.getSingleTexture('/textures/ui/ninimo_2.png'),
      TextureFactory.instance.getSingleTexture('/textures/ui/ninimo_3.png'),
      TextureFactory.instance.getSingleTexture('/textures/ui/ninimo_4.png'),
    ]);
    this.ninimoSprite.anchor.set(0.5);
    this.ninimoSprite.y = -90;
    this.addChild(this.ninimoSprite);

    this.stageSprite = new AnimatedSprite([
      TextureFactory.instance.getSingleTexture('/textures/ui/stage_1.png'),
      TextureFactory.instance.getSingleTexture('/textures/ui/stage_2.png'),
      TextureFactory.instance.getSingleTexture('/textures/ui/stage_3.png'),
      TextureFactory.instance.getSingleTexture('/textures/ui/stage_4.png'),
    ]);
    this.stageSprite.anchor.set(0.5);
    this.stageSprite.y = -575;
    this.addChild(this.stageSprite);

    const homeButton = new HomeButton();
    homeButton.interactive = true;
    homeButton.buttonMode = true;
    homeButton.x = 10;
    homeButton.y = 430;
    homeButton.on('clicked', () => {
      this.emit('home');
    });
    this.addChild(homeButton);

    const restartButton = new RestartButton();
    restartButton.interactive = true;
    restartButton.buttonMode = true;
    restartButton.x = 10;
    restartButton.y = 280;
    restartButton.on('clicked', () => {
      this.emit('ad');
    });
    this.addChild(restartButton);

    this.scoreText = new Text('0', {
      fontSize: 90,
      fontWeight: '900',
      fontFamily: 'ff-providence-sans-web-pro, sans-serif',
      fontStyle: 'normal',
      letterSpacing: -2,
      fill: '#002800',
    });
    this.scoreText.anchor.set(0.5);
    this.scoreText.x = 10;
    this.scoreText.y = -365;
    this.addChild(this.scoreText);

    this.note = new Text('', {
      fontSize: 45,
      align: 'center',
      fontWeight: '700',
      fontFamily: 'gaegu',
      fontStyle: 'normal',
      letterSpacing: -2,
      fill: '#002800',
      padding: 10,
    });
    this.note.anchor.set(0.5);
    this.note.y = 150;
    this.addChild(this.note);
  }

  public setScore(stage: string, score: string, rank: number, playername: string): void {
    this.gameState.stage = stage;
    this.gameState.score = score;
    this.gameState.rank = rank;
    const d = Store.instance.e(
      `${this.gameState.stage},${this.gameState.score},${this.gameState.rank},${Store.instance.data.playername}`,
      '89Gr9JE3HLD0KEMeAsbKCC7XLts5552w'
    );
    const textarea = document.getElementById('sharelink') as HTMLTextAreaElement;
    textarea.value = `https://ninimo.pinkfong.com/#/share?d=${encodeURIComponent(d)}`;

    switch (stage) {
      case '1':
        this.stageSprite.gotoAndStop(0);
        this.ninimoSprite.gotoAndStop(0);
        this.note.y = 150;
        if (Store.instance.state.locale === 'en-US') {
          this.note.text = `The veggies nailed it!\nSorry ${playername}...`;
        } else {
          this.note.text = `${playername}, 참패다!`;
        }
        break;
      case '2':
        this.stageSprite.gotoAndStop(1);
        this.ninimoSprite.gotoAndStop(1);
        this.note.y = 150;
        if (Store.instance.state.locale === 'en-US') {
          this.note.text = `Well..nice try, ${playername}`;
        } else {
          this.note.text = `${playername} 손에서 쥐가나 니니!`;
        }
        break;
      case '3':
        this.stageSprite.gotoAndStop(2);
        this.ninimoSprite.gotoAndStop(2);
        this.note.y = 150;
        if (Store.instance.state.locale === 'en-US') {
          this.note.text = `I beleive ${playername} can fly!`;
        } else {
          this.note.text = '눈 딱 감고 낙하~ 하아아';
        }
        break;
      case '4':
        this.stageSprite.gotoAndStop(3);
        this.ninimoSprite.gotoAndStop(3);
        this.note.y = 150;
        if (Store.instance.state.locale === 'en-US') {
          this.note.text = `Don’t let the Cucumber win,\n${playername}!`;
        } else {
          this.note.text = `${playername}, 오이한테 탈탈 털렸니니?`;
        }
        break;
      default:
    }
    if (rank !== -1) {
      this.note.y = 150;
      if (Store.instance.state.locale === 'en-US') {
        this.note.text = `You are ranked #${rank}!`;
      } else {
        this.note.text = `니니모 용사 ${playername}님!\n무려 랭킹 "${rank}"등이다 니니!`;
      }
    }

    this.scoreText.text = score;
  }

  public update(_elapsed: number): void {}
}

export default GameOverUI;
